<template>
	<div
		class="flex md:hidden text-white p-2 rounded focus:outline-none cursor-pointer"
	>
		<label for="menu-toggle">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				class="h-6 w-6 text-gray-500"
				fill="none"
				viewBox="0 0 24 24"
				stroke="white"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="2"
					d="M4 6h16M4 12h16M4 18h16"
				/>
			</svg>
		</label>
		<div class="flex-grow text-prunplanner text-xl pl-3">
			<span class="font-bold">PRUN</span>planner
		</div>
	</div>
</template>

<script setup lang="ts"></script>
